import { Component } from "react";
import { AppThemeProvider } from "../themes";
import { Error } from "./error";

export class ErrorBoundary extends Component<
	{
		appName: string;
		callback?: () => void | Promise<void>;
	},
	{ hasError: boolean }
> {
	constructor(props) {
		super(props);

		this.state = {
			hasError: false,
		};
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo) {
		console.log("[APP ERROR BOUNDARY]: ", {
			error,
			errorInfo,
			location: window.location,
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				<AppThemeProvider>
					<Error callback={this.props.callback} />
				</AppThemeProvider>
			);
		}

		return this.props.children;
	}
}
